import styles from './comment.delete.module.css';

function CommentBoxDelete(props) {
  return (
    <div id="commentBosDelete" className={`${styles.container}`}>
      <div className={`app-l-modal ${styles.alertInfo}`}>
        <div className="app-modal w-75">
          <div className="modal-content">
            <div class="app-modal-header modal-header ">{props.data?.headingText}</div>
            <div class="app-modal-content modal-body ">
              <p class="modal-sub-text">Are you sure? This process cannot be undone.</p>
              <div class="d-flex justify-content-center my-4">
                <button
                  type="button"
                  class="btn-primary btn-plane g--tint mx-4"
                  onClick={() => {
                    props.handleDelete?.();
                  }}
                >
                  YES<sup>*</sup>
                </button>
                <button
                  type="button"
                  class="btn-primary btn-plane g--tint mx-4"
                  onClick={() => {
                    props.closeModal?.();
                  }}
                >
                  NO
                </button>
              </div>
              <p class="modal-sub-note">
                <sup>*</sup>Please note that this action is irreversible
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CommentBoxDelete;
